import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { metaOverrideSet } from './metaOverrideSet';
import { GuidedHouseholdReviewOutroForHeadStartLayout } from './layout';

const layout = withGuidedHouseholdReviewLayout(
  GuidedHouseholdReviewOutroForHeadStartLayout,
  { fullWidth: true, hideTitle: true, customButtons: true },
);

export const GuidedHouseholdReviewOutroForHeadStartTemplate = ({ resource }) => {
  const { loadPageContentLink, setPageContentCollection, refreshPageContentCollection } = usePageContentContext();
  return (
    <MetaResourceRenderer
      resource={resource}
      layout={layout}
      metaOverrideSet={metaOverrideSet}
      onSubmit={setPageContentCollection}
      LayoutProps={{ navigateToLink: loadPageContentLink, refresh: refreshPageContentCollection }}
    />
  );
};

GuidedHouseholdReviewOutroForHeadStartTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
